import { render } from "./PresentationHome.vue?vue&type=template&id=7db33a78&scoped=true&ts=true"
import script from "./PresentationHome.vue?vue&type=script&lang=ts"
export * from "./PresentationHome.vue?vue&type=script&lang=ts"

import "./PresentationHome.vue?vue&type=style&index=0&id=7db33a78&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db33a78"]])

export default __exports__